import { useEffect, useMemo, useRef } from 'react';

import createSharedState from 'hooks/createSharedState';

import useVoiceState from './useVoiceState';

const [useSpeechRecognitionInstance, _getSpeechRecognitionInstance, setSpeechRecognitionInstance] =
  createSharedState<any>(null);

if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
  // @ts-expect-error FIXME TS2339
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const speechRecognition = new SpeechRecognition();
  speechRecognition.lang = 'en-US';
  speechRecognition.continuous = false;
  speechRecognition.interimResults = true;
  setSpeechRecognitionInstance(speechRecognition);
}

type Subscriber = {
  onResult?: (value: string) => void;
  onEnd?: () => void;
};
let subscribers: Subscriber[] = [];

const useSpeechRecognition = (onResult?: (value: string) => void, onEnd?: () => void) => {
  const [, setVoiceState] = useVoiceState();
  const [speechRecognition] = useSpeechRecognitionInstance();

  const subscriberRef = useRef<Subscriber>(undefined);
  useEffect(() => {
    if (onResult || onEnd) {
      subscriberRef.current = { onResult, onEnd };
      subscribers.push(subscriberRef.current);
    }
    return () => {
      subscribers = subscribers.filter((subscriber) => subscriber !== subscriberRef.current);
    };
  }, [onResult, onEnd]);
  useEffect(() => {
    if (speechRecognition) {
      speechRecognition.onstart = () => setVoiceState('LISTENING');
      speechRecognition.onresult = (event: any) => {
        const { transcript } = event.results[0][0];
        subscribers.forEach((subscriber) => subscriber?.onResult?.(transcript));
      };
      speechRecognition.onend = (_event: any) => {
        subscribers.forEach((subscriber) => subscriber?.onEnd?.());
        setVoiceState('IDLE');
      };
    }
  }, [speechRecognition, setVoiceState]);

  const protocol = useMemo(
    () => ({
      startRecognition: () => speechRecognition?.start(),
      stopRecognition: () => speechRecognition?.stop(),
    }),
    [speechRecognition],
  );
  return protocol;
};

export default useSpeechRecognition;
